/* eslint-disable no-empty-character-class */
const RegexSpecial = (value) => {
  const pattern = /[$^"'{}|\[\]]/g;
  const matches = value.match(pattern);
  return matches && matches.length > 0 ? true : false;
};

export default RegexSpecial;
